import Layout from "../../components/Layout/Layout";
import PageTitle from "../../components/PageTitle/PageTitle";
import Button from "../../components/Button/Button";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { useEffect, useState } from "react";
import { TableSearch } from "../../components/Table/TableActions";
import Table from "../../components/Table/Table";
import { Icon } from "@iconify/react";
import InputGroup from "../../components/FormComponent/InputGroup";
import TextAreaGroup from "../../components/FormComponent/TextAreaGroup";
import Modal from "../../components/Modal";
import { Grid } from "@mui/material";

// --Dummy Data
import EmailTemplateInfo from "../../dummy_data/emailformat.json";

const EmailTemplate = () => {
  const [searchResult, setSearchResult] = useState([]);
  const [currentRow, setCurrentRow] = useState({});
  const [deleteModal, setDeleteModal] = useState(false);
  const [createtemplatemoddal, setCreateTemplateModal] = useState(false);
  const [edittemplatemodal, setEditTemplateModal] = useState(false);
  const [viewmodal, setViewModal] = useState(false);

  const handleViewModal = () => {
    setViewModal(!viewmodal);
  };

  const handleEditTemplateModal = () => {
    setEditTemplateModal(!edittemplatemodal);
  };

  const handleCreateTemplateModal = () => {
    setCreateTemplateModal(!createtemplatemoddal);
  };

  const handleDeleteModal = (row) => {
    setCurrentRow(row);
    setDeleteModal(!deleteModal);
  };

  const columns = [
    {
      name: "Title",
      selector: row => row?.title
    },
    {
      name: "Prompt",
      selector: row => row?.prompt
    },
    {
      name: "Created on",
      selector: row => row?.date_created
    },
    {
      name: "Last updated",
      selector: row => row?.last_updated
    },
    {
      name: "",
      center: true,
      sortable: false,
      cell: (row) => (
        <div key={row?.id} className="table-action-container">
          <button onClick={handleEditTemplateModal} className="table-action-icon">
            <Icon icon="nimbus:edit" />
          </button>
          <button onClick={handleViewModal} className="table-action-icon">
            <Icon icon="fluent:eye-16-regular" />
          </button>
          <button
            onClick={() => handleDeleteModal(row)}
            className="table-action-icon delete-icon"
          >
            <Icon icon="mingcute:delete-2-line" />
          </button>
        </div>
      )
    }
  ];

  useEffect(() => {
    // The data will be from the Email get api endpint
    setSearchResult(EmailTemplateInfo);
  }, []);

  // --| Filter Shelf21 table using name, email and class
  const handleAdminSchools = (e) => {
    const { value } = e.target;

    const valArray = value.split(" ");
    // --| Filter data by partial match onchange in the search input box
    const result = EmailTemplateInfo?.filter((data) => valArray?.every(
      (word) => data?.name
        ?.toLowerCase()
        .includes(word.toLowerCase()) ||
                                    data?.description
                                      ?.toLowerCase()
                                      .includes(word.toLowerCase()) ||
                                    data?.category
                                      ?.toLowerCase()
                                      .includes(word.toLowerCase()) ||
                                      data?.status
                                        ?.toLowerCase()
                                        .includes(word.toLowerCase())
    )
    );
    setSearchResult(result);
  };

  return (
    <Layout
      children={
        <>
          <PageTitle
            title="Email Template"
            subtitle="Save and embedded all your emails going out easily."
            button={
              <Button
                variant="primary"
                buttonSize="fluid"
                color="btndefault"
                onClick={handleCreateTemplateModal}
                buttonName={<div className="flex align-items-center gap-5"><span><AddCircleOutlineIcon /></span>Create Email Template</div>}
              />
            }
          />
          <Table data={searchResult} columns={columns} subHeader={true} pagination subHeaderComponent={
            <TableSearch placeholder="Search here..." searchTableFunc={handleAdminSchools} />
          }
          />
          {/* CREATE EMAIL TEMPLATE */}
          <Modal
            title="Create Template"
            subtitle={
              <div>Here you can save and embedded the code for email templates.
              </div>}
            modalContent={
              <>
                <Grid container spacing={2} className="input-padding">
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <InputGroup
                      label="Title"
                      margin="normal"
                      placeHolder="What is the title of mail."
                      inputType="text"
                    />
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <InputGroup
                      label="Prompt"
                      margin="normal"
                      placeHolder="When you reset password."
                      inputType="text"
                    />
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <TextAreaGroup
                      label="Embedded code"
                      margin="normal"
                      placeholder="Show Embedded code"
                    />
                  </Grid>
                </Grid>
              </>
            }
            modalFooter={
              <>
                <Button variant="primary" buttonSize="full" color="btndefault" buttonName="Create Template" />
              </>
            }
            isopen={createtemplatemoddal}
            closeModal={handleCreateTemplateModal}
          />
          {/* EDIT EMAIL TEMPLATE */}
          <Modal
            title={<div>Edit<span className="modal-name-highlight">{currentRow?.title}</span>Template</div>}
            subtitle={
              <div>Here you can edit and embed the code for email templates.
              </div>}
            modalContent={
              <>
                <Grid container spacing={2} className="input-padding">
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <InputGroup
                      label="Title"
                      margin="normal"
                      placeHolder="What is the title of mail."
                      inputType="text"
                    />
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <InputGroup
                      label="Prompt"
                      margin="normal"
                      placeHolder="When you reset password."
                      inputType="text"
                    />
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <TextAreaGroup
                      label="Embedded code"
                      margin="normal"
                      placeholder="Show Embedded code"
                    />
                  </Grid>
                </Grid>
              </>
            }
            modalFooter={
              <>
                <Button variant="primary" buttonSize="full" color="btndefault" buttonName="Create Template" />
              </>
            }
            isopen={edittemplatemodal}
            closeModal={handleEditTemplateModal}
          />
          {/* View EMAIL TEMPLATE */}
          <Modal
            title="Enrolment Application Email Template"
            subtitle={
              <div>See the template that goes out when an application has been submitted.
              </div>}
            modalContent={
              <>
              </>
            }
            modalFooter={
              <></>
            }
            isopen={viewmodal}
            closeModal={handleViewModal}
          />
          {/* Delete Modal */}
          <Modal
            title="Delete Email Template"
            subtitle={
              <div>Are you sure you want to remove <span className="modal-name-highlight">{currentRow?.title}</span>. from one of your Template? Removing it will permanently clear this Template.`
              </div>}
            modalContent={
              <>

              </>
            }
            modalFooter={
              <>
                <div className="flex gap-10">
                  <Button
                    variant="dangeroutline"
                    buttonSize="full"
                    color="btndanger"
                    buttonName="Cancel"
                  />
                  <Button variant="danger" buttonName="Remove Contractor" buttonSize="full" color="btndefault" />
                </div>
              </>
            }
            isopen={deleteModal}
            closeModal={handleDeleteModal}
          />
        </>
      }
    />
  );
};

export default EmailTemplate;
